import { Box } from "@mui/material";
import React, { Dispatch, SetStateAction, useState } from "react";
import { Button, Card, CardBody, CardHeader } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Http } from "../../utils/constants";
import { checkEmailExists } from "../../utils/helpers/api";
import { useGlobalState } from "../../contexts/GlobalContext";
import { AxiosResponse } from "axios";

interface IReSendMailProps {
  email: string;
  setIsResend: Dispatch<SetStateAction<boolean>>;
}

const ResendMail: React.FC<IReSendMailProps> = (props) => {
  const { email, setIsResend } = props;
  const { t } = useTranslation();
  const { setStateValue } = useGlobalState();

  const handleSendEmailVerify = async () => {
    setStateValue("loader", true);

    try {
      const response = (await checkEmailExists(email ?? "", true)) as AxiosResponse;
      if (response && response.data.user) {
        setIsResend(false);
      } else {
        setIsResend(true);
      }
    } catch (error) {
      return;
    } finally {
      setStateValue("loader", false);
    }
  };

  return (
    <Box className="page__register--confirm d-flex justify-content-center mt-4">
      <Card className="card">
        <CardHeader className="card-header">
          <label className="title">{t("features.resendEmail.resendEmail")}</label>
        </CardHeader>

        <CardBody>
          <div className="form-group">
            <div>
              {t("features.resendEmail.resendText")} "{email}"{t("features.resendEmail.resendText2")}
            </div>
          </div>
          <Box className="center mt-4">
            <Button className="btn btn-primary form-control btn-md" onClick={() => handleSendEmailVerify()}>
              {t("features.register.send_mail")}
            </Button>
          </Box>
        </CardBody>
      </Card>
    </Box>
  );
};

export default ResendMail;
